import { styled } from "@mui/material/styles";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

/**
 * Styled IconButton that visually rotates to indicate expansion state.
 *
 * Args:
 *   expand (boolean): Controls rotation (180deg when expanded).
 *   ...IconButtonProps: Additional IconButton props forwarded to the button.
 *
 * Returns:
 *   JSX.Element: IconButton with rotation tied to `expand`.
 *
 * Notes:
 *   - Stateless; visual-only utility component.
 */
export const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ expand }: ExpandMoreProps) => ({
  marginLeft: "auto",
  transition: "transform 150ms ease",
  transform: expand ? "rotate(180deg)" : "rotate(0deg)",
}));
